export default __webpack_public_path__ + "static/media/tabeliaorc.ffe22078.jpeg";